/**
 * 实训云管理侧正则表达式
 */

export class RegService {
  // 账号由中文、英文大小写、数字和下划线组成
  static readonly USERNAME = /^[\d\w\u4e00-\u9fa5]+$/;
  // 账号不能由纯数字组成
  static readonly NUMBER = /^[0-9]*$/;

  static readonly VMNAME = /^[A-Za-z]+$/;

  // 名称(姓名)由中文、英文大小写、任意数字组成
  static readonly REALNAME = /^[A-Za-z0-9\u4e00-\u9fa5]+$/;

  // 中文、英文大小写、数字和括号组成
  static readonly MATERIAL_NAME = /^[A-Za-z0-9\u4e00-\u9fa5()（）]+$/;

  // 手机号
  static readonly PHONE = /^1[3456789]\d{9}$/;

  // 域名
  static readonly ORG = /^[a-zA-Z\d-]+(\.[a-zA-Z\d-]+){2}$/;

  // 密码只能包含大写字母、小写字母、数字和特殊字符且至少包含四种字符中的三种
  static readonly PASSWORD = /^(?![A-Za-z]+$)(?![A-Z\d]+$)(?![A-Z\W]+$)(?![a-z\d]+$)(?![a-z\W]+$)(?![\d\W]+$)\S{1,}$/;

  // 包含大写字母、小写字母、数字和特殊字符且至少包含四种字符中的三种 且需要8位,兼容老平台用户，由8-26改为6-32
  static readonly PASSWORD_ICT = /^(?![a-zA-Z]+$)(?![A-Z0-9]+$)(?![A-Z\W_]+$)(?![a-z0-9]+$)(?![a-z\W_]+$)(?![0-9\W_]+$)[a-zA-Z0-9\W_]{8,26}$/;

  // 不能连续重复字段
  static readonly PASSWORD_REPEAT_4 = /([0-9a-zA-Z])\1{4,}/;

  // 验证码正则
  static readonly CODE_4 = /^\d{4}$/;

  // 连续数字或者字母 连续num位或num位以上
  static readonly LxStr = function(str, num) {
    const arr = str.split("");
    let flag = false;
    // safe_12
    for (let i = 0; i < arr.length - num + 1; i++) {
      const indexArr = arr.slice(i, i + num).map(word => {
        return word.charCodeAt();
      });
      const notIndex = indexArr.findIndex((indexItem, index) => {
        return (
          index + 1 < indexArr.length && indexArr[index + 1] - indexItem != 1
        );
      });
      if (notIndex < 0) {
        flag = true;
        break;
      }
    }
    return flag;
  };

  // 校验码只能由正整数组成
  static readonly CODE = /[^0-9]/;

  // 电子邮箱
  static readonly EMAIL = /^[-_.a-zA-Z0-9]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+/;

  // 课件名称(不包含首尾空格的校验) 命名不得包含下列任意字符:/?\*"<>|
  static readonly COURSEWARE_NAME = /^[^/\\:<>*|"?]{1,50}$/;

  // 习题名称(不包含首尾空格的校验) 命名不得包含下列任意字符:/?\*"<>|
  static readonly QUESTION_NAME = /^[^/\\:<>*|"?]{1,1500}$/;
  // 课件名称(不包含首尾空格的校验) 命名不得包含下列任意字符:/?\*"<>|
  static readonly KNOWLEAGE_NAME = /^[^/\\:<>*|"?]{1,100}$/;

  // 实验路径
  static readonly LAB_URL = /^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w.-]+)+[\w\-._~:/?#[\]@!$&'*+,;=.]+$/;

  // 企业账号由英文大小写、任意数字-_组成
  static readonly ENTERPRISE_ACCOUNT = /^[A-Za-z0-9_-]+$/;

  // 企业账号ID由英文大小写、任意数字组成
  static readonly ENTERPRISE_ACCOUNT_ID = /^[A-Za-z0-9]+$/;

  // 企业账号密码由英文大小写、任意数字组成
  static readonly ENTERPRISE_PASSWORD = /^[\d\w!@#$%^&*_-]+$/;

  // 企业额度
  static readonly QUOTA = /((^[1-9]\d*)|^0)(\.\d{0,2}){0,1}$/;

  // 广告位名称 只能包含 中文、英文safe_16
  static readonly ADVERTISING_NAME = /^[\u4e00-\u9fa5a-zA-Z]*$/;

  // 英文名称(暂定只由英文字母组成)
  static readonly ENGLISH_NAME = /^[a-zA-Z]+$/;

  // 验证码正则6
  static readonly CODE_6 = /^\d{6}$/;
  // 匹配所有汉字包括生僻字
  static readonly ALL_CHARACTERS = /^((?![\u3000-\u303F])[\u2E80-\uFE4F])*$/;

  // pdf当前页码只能是正整数(不包括0)
  static readonly PDF_PAGE = /^[0-9]*[1-9][0-9]*$/;
}
